import { render, staticRenderFns } from "./RELHistoricoVeiculo.vue?vue&type=template&id=4db6013f&scoped=true&"
import script from "./RELHistoricoVeiculo.vue?vue&type=script&lang=js&"
export * from "./RELHistoricoVeiculo.vue?vue&type=script&lang=js&"
import style0 from "./RELHistoricoVeiculo.vue?vue&type=style&index=0&id=4db6013f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db6013f",
  null
  
)

export default component.exports